import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "../design-system.css";
import "./styles.css";
import "./theme/rnr-tokens.css";
import "./theme/rnr-theme.css";
import "./table-filters.css";
import { enhanceTables } from "./table-filters";

class DashboardErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        <main style={{ maxWidth: 540, margin: "12vh auto", padding: 32, fontFamily: "system-ui, sans-serif" }}>
          <h1>Lead Alchemy could not open</h1>
          <p role="alert">Something interrupted the page. Reload to try again.</p>
          <button type="button" onClick={() => window.location.reload()}>Reload dashboard</button>
        </main>
      );
    }
    return this.props.children;
  }
}

const root = document.getElementById("root")!;
ReactDOM.createRoot(root).render(
  <React.StrictMode><DashboardErrorBoundary><App /></DashboardErrorBoundary></React.StrictMode>,
);

// Excel-style filters on every table, in the hub and the portal.
enhanceTables(root, () => location.pathname + location.search);
